import {
  SUP_VEHICLE_LIST, SUP_VEHICLE_LIST_SUCCESS, SUP_VEHICLE_LIST_ERROR,
  SUP_VEHICLE_PAGE_SET,
  SUP_VEHICLE_ADD, SUP_VEHICLE_ADD_SUCCESS, SUP_VEHICLE_ADD_ERROR,
  SUP_VEHICLE_ADD_CHANGE,
  SUP_VEHICLE_DETAIL, SUP_VEHICLE_DETAIL_SUCCESS, SUP_VEHICLE_DETAIL_ERROR,
  SUP_VEHICLE_UPDATE, SUP_VEHICLE_UPDATE_SUCCESS, SUP_VEHICLE_UPDATE_ERROR,
  SUP_VEHICLE_FILTER_TYPE_SUCCESS,
  SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'id_vehicle', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  detail: { loading: false, data: null },
  add: { data: { new: { id_supplier: '', id_vehicle_type: '', code: '', brand: '', model: '', color: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  filters: { vehicle_types: [], suppliers: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SUP_VEHICLE_LIST: return { ...state, loading: true };
    case SUP_VEHICLE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case SUP_VEHICLE_LIST_ERROR: return { ...state, loading: false, error: true };
    case SUP_VEHICLE_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case SUP_VEHICLE_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case SUP_VEHICLE_ADD: return { ...state, add: { ...state.add, loading: true } };
    case SUP_VEHICLE_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { id_supplier: '', id_vehicle_type: '', code: '', brand: '', model: '', color: '' } } } };
    case SUP_VEHICLE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case SUP_VEHICLE_DETAIL: return { ...state, detail: { ...state.detail, loading: true } };
    case SUP_VEHICLE_DETAIL_SUCCESS: return { ...state, detail: { loading: false, data: action.payload } };
    case SUP_VEHICLE_DETAIL_ERROR: return { ...state, detail: { loading: false, data: null } };
    case SUP_VEHICLE_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case SUP_VEHICLE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case SUP_VEHICLE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    case SUP_VEHICLE_FILTER_TYPE_SUCCESS: return { ...state, filters: { ...state.filters, vehicle_types: action.payload } };
    case SUP_VEHICLE_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    default: return { ...state };
  }
};
